module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAT9JREFUSA3tlr9KA0EQxn9zHKlSaRo7H8PK1iKlvUI6n0A8RE5RScDWFxCsbdTCUrDyQWw0FpYXs84mZPUucjcHd10GFnbnz/fNzu4yK6Suw4QzHHs6NmhChDeEG2JO4hn4lMMmcAOGT9Qp5gTl8Jl7iehzLo/BKXHvOl+nS49EPoLeMklcX93uPXYUyvIX3AJS5nMpDzOz7iQq82vC1jpBbM4ycQO9Gful/sIod47qbCeAHT2v7QqCF7X/XpRaBB0OyLguJVjjtWi37yCVsQY/FwGq1jUI3CbfbAXAqRasyxNH8hl0/0zsBBlXCrmbw/gi1fVpTldY2AngVmOzEC9KB/MHFZTLEzvBhdxpuB+1pPWHtiKoPI9ViQwl8g3ay7zNVQaYHBZYii0cuyFNN/1FFhGj2H8tfPfXh9/Kt+UH9TxKFrhsw3gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/icon-pmmc.png
// module id = 145
// module chunks = 2